import { SystemStats } from "src/domain/entities/admin"
import { ApiRequester } from "../ApiRequester"

export async function systemStatsGetApi(token?: null | string) {
	const endpoint = "/system/stats/get/v1"
	const requester = new ApiRequester<{}, SystemStats>(endpoint)
	return await requester.sendRequest({}, token)
}
